<template>
  <div class="influence-container">
    <div class="influence-type-container">
      <el-radio v-model="selectedType" name="influences-type" label="importance" :disabled="!influences.importance">
        影響度(データ変換あり)
      </el-radio>
      <el-radio v-model="selectedType" name="influences-type" label="importanceX" :disabled="!influences.importanceX">
        影響度(データ変換なし)
      </el-radio>
      <el-radio v-model="selectedType" name="influences-type" label="weight" :disabled="!influences.weight">係数
      </el-radio>
    </div>

    <div class="influences-main-container influences-ranking-container">
      <fixed-header-table :fixed="selectedInfluenceResult != null">
        <tr slot="header">
          <th style="flex-grow: 0; justify-content: center;">順位</th>
          <th>項目名</th>
          <th v-if="selectedType !== 'weight'">影響度</th>
          <th v-else>係数</th>
        </tr>
        <tr v-if="selectedInfluenceResult.hasOwnProperty('value') && !isRemoved(influence.label)" v-for="(influence, index) in selectedInfluenceResult.value" :key="index">
          <td style="flex-grow: 0;">{{(index + 1) | number_format}}</td>
          <td :title="influence.label"><span class="label-wrapper">{{influence.label}}</span></td>
          <td v-if="selectedType !== 'weight'" class="with-bar-chart" :style="getBarChartStyleObj(influence.influence)">{{influence.influence | percentage_format(2, true) }}</td>
          <td v-else class="with-bar-chart" :style="getBarChartStyleObj(influence.influence, selectedInfluenceResult.maxAbs)">{{ influence.influence }}</td>
        </tr>
        <tr v-if="selectedType" v-for="removedX in influences.removed[selectedType]" style="background: #abb5bf;">
          <td style="flex-grow: 0; justify-content: center;">削除</td>
          <td :title="removedX"><span class="label-wrapper">{{removedX}}</span></td>
          <td> - </td>
        </tr>
      </fixed-header-table>
    </div>

    <div class="influence-column-container" v-if="influences.classes.length > 1">
      <el-radio v-for="(clazz, index) in influences.classes" v-model="selectedColumnIndex" name="influences-column"
                :label="index">{{ clazz }}
      </el-radio>
    </div>
  </div>
</template>

<script lang="js">
import { Influences } from '../../../defines/model/influence'
import CommonUtil from '../../../utils/common'

export default {
  name: 'InfluencesRankingCmp',
  props: {
    influences: {type: Object, default: Influences}
  },
  data () {
    return {
      selectedType: '',
      selectedColumnIndex: -1,
      selectedInfluenceResult: null
    }
  },
  computed: {
    getBarChartStyleObj () {
      return function (value, maxAbs = null) {
        const color = value > 0 ? '#cee5ff' : 'rgba(255,161,187,0.62)'

        if (maxAbs !== null) {
          value = Math.abs(value) / maxAbs
        }

        const width = value * 100
        return {
          background: `linear-gradient(90deg,${color} ${width}%,${color} ${width}%, white ${width}%, white 100%)`
        }
      }
    }
  },
  created () {
    if (CommonUtil.isNotEmpty(this.influences.importance)) {
      this.selectedType = 'importance'
    } else if (CommonUtil.isNotEmpty(this.influences.importanceX)) {
      this.selectedType = 'importanceX'
    } else {
      this.selectedType = 'weight'
    }
    this.selectedColumnIndex = 0

    this.selectedInfluenceResult = this.influences[this.selectedType][0]
  },
  watch: {
    selectedColumnIndex (newIndex) {
      this.switchDisplay(this.selectedType, newIndex)
    },
    selectedType (newType) {
      this.switchDisplay(newType, this.selectedColumnIndex)
    }
  },
  methods: {
    switchDisplay (type, index) {
      if (type && index > -1) {
        this.selectedInfluenceResult = this.influences[type][index]
      }
    },
    isRemoved (xLabel) {
      if (this.influences.removed[this.selectedType] !== null) {
        return this.influences.removed[this.selectedType].indexOf(xLabel) >= 0
      }
      return false
    }
  }
}

</script>

<style scoped>
  .influence-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .influence-type-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .influences-main-container {
    flex-grow: 1;
    padding: 16px 20px;
  }

  .influences-chart-container {
    padding-top: 0;
  }

  .influences-ranking-container {
    display: flex;
    flex-direction: column;
  }

  .influences-ranking-container > div {
    max-height: 430px;
    flex-grow: 1;
  }

  .influence-column-container {
    padding: 0 24px 16px 24px;
  }

  .tab-menu {
    display: flex;
    flex-shrink: 0;
    border-top: 1px solid #c0d5ef;
    background: #f1f5f8;
  }

  .tab-menu.el-menu.el-menu--horizontal {
    border-bottom: 1px solid #c0d5ef;
  }

  .tab-menu.el-menu--horizontal >>> .el-menu-item {
    flex-grow: 1;
    color: #2456d4;
    text-align: center;
    text-decoration-line: underline;
    border: none;
    width: 50%;
    height: 50px;
    line-height: 52px;
  }

  .tab-menu.el-menu--horizontal >>> .el-menu-item:not(.is-disabled):hover,
  .tab-menu.el-menu--horizontal >>> .el-menu-item.is-active {
    background-color: #6ba7ef;
    color: #fff;
    text-decoration: none;
    border: none;
  }

  .tab-menu.el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  .tab-menu.tab-menu-second.el-menu--horizontal >>> .el-menu-item:not(.is-disabled):hover,
  .tab-menu.tab-menu-second.el-menu--horizontal >>> .el-menu-item.is-active {
    background-color: #b5d3f7;
    color: #2456d4;
  }

  .with-bar-chart {
    background-clip: content-box;
    padding: 0.5rem 1rem 0.5rem 1rem !important;
  }

  .label-wrapper {
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/model/detail/influences.vue